import React, {Component} from 'react';
import PropTypes from 'prop-types';
import GeneralUtils from "../../utils/GeneralUtils";


export class AppInlineProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        };
        this.onClick = this.onClick.bind(this);

    }

    componentDidMount = () => {
    }

    onClick(event) {
        this.setState({expanded: !this.state.expanded});
        event.preventDefault();
    }

    render() {
        const initials = GeneralUtils.getUserInitials();
        const displayName = GeneralUtils.getUserDisplayName();

        return (
            <div className="app-sidebar-profile-block">
                <div className="profile app-sidebar-profile">
                    <div className="app-sidebar-profile__avatar" aria-hidden="true">
                        {initials}
                    </div>
                    <div className="app-sidebar-profile__details">
                        <span className="app-sidebar-profile__name">{displayName}</span>
                    </div>
                </div>
            </div>
        );
    }
}

AppInlineProfile.propTypes = {
    logout: PropTypes.func
};
